<span *ngIf="type === 'PRODUCTION'">
                <img matTooltip="{{'VIDEO.PURCHASE_ORDER.TABLE.PRODUCTION' | translate}}"
                     src="assets/img/production2706v1.gif"/>
              </span>
<span *ngIf="type === 'MARKETING'">
                <img matTooltip="{{'VIDEO.PURCHASE_ORDER.TABLE.MARKETING' | translate}}"
                     src="assets/img/marketing2706v1.gif"/>
              </span>
<span *ngIf="type === 'MANUFACTURING'">
                <img matTooltip="{{'VIDEO.PURCHASE_ORDER.TABLE.MANUFACTURING' | translate}}"
                     src="assets/img/fabrication2706v1.gif"/>
              </span>
<span *ngIf="type === 'VOD'">
                <img matTooltip="{{'VIDEO.PURCHASE_ORDER.TABLE.VOD' | translate}}"
                     src="assets/img/marketing2706v1.gif"/>
              </span>
